import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@tq/ui-components';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';

import { RpcOtherResponseAnswers } from '../RpcOtherResponse/RpcOtherResponseAnswers';
import { RpcOtherResponse } from '../RpcOtherResponse';
import { ConsultationResponseAnswer } from 'types';

export const ArchivedRpcResponses: React.FC<{
  otherAnswers: ConsultationResponseAnswer[];
  pastAnswers: ConsultationResponseAnswer[];
}> = ({ otherAnswers, pastAnswers }) => {
  const { t } = useTranslation('consultation_response');
  return (
    <>
      <>
        <Box
          p={{ base: 0, lg: 4 }}
          border={{ base: 'none', lg: `1px solid ${COLOURS.gray[300]}` }}
        >
          <Box p={{ base: 4, lg: 2 }} pb={{ base: 4, lg: 6 }}>
            <h3>
              <strong>{t('from_your_organisation_response', 'From your organisation')}</strong>
            </h3>
          </Box>
          <Box px={{ base: 4, lg: 0 }}>
            {pastAnswers.map((answer) => (
              <RpcOtherResponseAnswers key={answer.id} answer={answer} />
            ))}
            {!pastAnswers?.length && (
              <Box px={{ base: 0, lg: 2 }}>
                {t('no_other_answers_message', 'No responses to display')}
              </Box>
            )}
          </Box>
        </Box>
        <Box
          p={{ base: 0, lg: 4 }}
          border={{ base: 'none', lg: `1px solid ${COLOURS.gray[400]}` }}
          borderTop={'0'}
        >
          <Box p={{ base: 4, lg: 2 }} pb={{ base: 4, lg: 6 }}>
            <h3>
              <strong>
                {t('other_organisation_responses', 'Other organisation responses')}
              </strong>
            </h3>
          </Box>
          <Box px={{ base: 4, lg: 0 }}>
            {otherAnswers.map((answer) => (
              <RpcOtherResponse key={answer.id} answer={answer} />
            ))}
            {!otherAnswers?.length && (
              <Box px={{ base: 0, lg: 2 }}>
                {t('no_other_answers_message', 'No responses to display')}
              </Box>
            )}
          </Box>
        </Box>
      </>
    </>
  );
};
